import React from "react"
import StrapiMedia from "../strapi-media"

const Stories = ({ data }) => {
  if (!data) return <div></div>
  const { stories, html } = data?.attributes

  return (
    <section className="max-w-screen-2xl w-full px-7 2xl:px-0 mx-auto mt-10">
      <div className="sm:w-2/3 lg:w-auto max-w-screen-lg xl:max-w-screen-xl w-full mx-auto flex flex-col lg:flex-row justify-around">
        {stories.data.map(story => {
          const { title, desc, content, image } = story.attributes
          return (
            <div
              className="lg:max-w-lg xl:max-w-xl flex-1 mb-16 lg:px-5"
              key={title}
            >
              <div
                className="font-cardo lg:font-cardo--46 xl:font-cardo--53 leading-none mb-5 lg:mb-10 lg:min-h-[200px]"
                dangerouslySetInnerHTML={{ __html: title }}
              ></div>
              <StrapiMedia
                image={image}
                className="w-full my-5 lg:my-10 lg:min-h-[315px]"
              />
              <div
                className="font-syne--22 font-bold mb-6 lg:min-h-[180px]"
                dangerouslySetInnerHTML={{ __html: desc }}
              ></div>
              <div
                className="font-montserrat--18"
                dangerouslySetInnerHTML={{ __html: content }}
              ></div>
            </div>
          )
        })}
      </div>
      <div dangerouslySetInnerHTML={{ __html: html || "" }}></div>
      <div className="max-w-screen-2xl w-full mx-auto lg:mt-20 border-b"></div>
    </section>
  )
}

export default Stories
